import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-instructors-style-three',
  templateUrl: './instructors-style-three.component.html',
  styleUrls: ['./instructors-style-three.component.scss']
})
export class InstructorsStyleThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
